/* User defined models */
import { PoliticalUnit } from '../scheduling/politicalUnit';
import { DynamicFormBase } from './dynamic-form-base.model';


export class ProSchedulerDropdown extends DynamicFormBase<string> {
  controlType = 'dropdown';
  options: PoliticalUnit[] = [];
  values: string[] = [];
  selectedOption: PoliticalUnit;

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
    this.values = options['values'] || [];
  }

  setSelectedOptionInternally() {
    // Country uses 'Name' instead of 'name' because of course it does
    this.selectedOption = !!this.options && !!this.options.length ? this.options.find((option) => option.name === this.value || option['Name'] === this.value) : null;
  }

  get valueRequiresChildren(): boolean {
    return !!this.value && this.value !== '-1' && !!this.selectedOption && !!this.selectedOption['Children'];
  }
}
